<template>
  <sidebar-row
    v-if="computedReadOnly"
    :border-bottom="hasDivider"
    :align-class="oneLineInput ? 'align-baseline' : 'align-center'"
    class="py-2"
    :has-icon-column="hasIconColumn"
    :padding-right="paddingRight"
  >
    <template #sectionTitle v-if="sectionTitle">
      <v-row no-gutters class="pt-1 pb-2">
        <v-col cols="1" style="min-width: 40px"></v-col>
        <v-col>
          <div class="text-left font-weight-medium subtitle-2">
            {{ $i18n.t(sectionTitle) }}
          </div>
        </v-col>
      </v-row>
    </template>
    <template #actionIcon v-if="hasIconColumn">
      <v-row no-gutters>
        <v-col>
          <v-icon color="rgba(0,0,0,0.7)" :size="iconSize" v-text="icon" />
        </v-col>
      </v-row>
    </template>
    <v-row no-gutters :class="{ 'pb-4': hasDivider }" :align="alignClass" :justify="justifyClass">
      <v-col v-if="hasNameColumn" :cols="nameCols" class="sidebar-form-name pr-2">
        <v-row no-gutters>
          {{ straightTitle || $i18n.t(translationPath) }}:
          <span style="color: red; padding-left: 2px" v-if="isEditingOn && !hideRulesIcon"
            >{{ rules.length > 0 ? '*' : '' }}
          </span>
        </v-row>
        <template v-if="hasSubtitle">
          <v-row no-gutters v-if="hasSmallSubtitle" class="pr-7">
            <v-col cols="12" class="small-subtitle">
              {{ $i18n.t(subtitlePath) }}
            </v-col>
          </v-row>
          <v-row no-gutters v-else>
            <italic-subheader :translation-path="subtitlePath" />
          </v-row>
        </template>
      </v-col>
      <v-col :cols="cols" class="sidebar-form-input">
        <slot :name="name" v-bind="{ ...$props, ...$attrs }">
          <feature-card-data-row-input
            dense
            :value="value"
            :rules="rules"
            :data-type="dataType"
            :is-editing-on="isEditingOn"
            v-bind="$attrs"
            v-on="$listeners"
            @input="$emit('input', $event)"
          />
        </slot>
      </v-col>
      <v-col cols="1" class="pl-4" v-if="appendIcon">
        <v-tooltip bottom color="font" max-width="180">
          <template #activator="{ on }">
            <v-icon v-on="on" v-if="appendIcon" @click="$emit('appendIconClicked', name)" color="font">
              {{ appendIcon }}
            </v-icon>
          </template>
          {{ appendIconTooltip }}
        </v-tooltip>
      </v-col>
    </v-row>
  </sidebar-row>
</template>

<script>
import FeatureCardDataRowInput from '@/components/FeatureCardDataRowInput';
import SidebarRow from '@/components/SidebarRow';
import ItalicSubheader from '@/components/ItalicSubheader';

export default {
  name: 'SidebarFormRow',
  components: {
    SidebarRow,
    ItalicSubheader,
    FeatureCardDataRowInput,
  },
  props: {
    value: {
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    straightTitle: {
      type: String,
      default: '',
    },
    translationPath: {
      type: String,
      default: '',
    },
    subtitlePath: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      required: false,
    },
    sectionTitle: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: '20px',
    },
    hasDivider: {
      type: Boolean,
      default: false,
    },
    hasGap: {
      type: Boolean,
      default: false,
    },
    hasNameColumn: {
      type: Boolean,
      default: true,
    },
    hasSubtitle: {
      type: Boolean,
      default: false,
    },
    hasSmallSubtitle: {
      type: Boolean,
      default: false,
    },
    hasIconColumn: {
      type: Boolean,
      default: true,
    },
    readOnlyField: {
      type: Boolean,
      default: false,
    },
    dataType: {
      type: Object,
      required: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    cols: {
      type: String,
      default: '7',
    },
    oneLineInput: {
      type: Boolean,
      default: true,
    },
    isEditingOn: {
      type: Boolean,
      default: false,
    },
    nameCols: {
      type: String,
      default: '4',
    },
    hasAppendIcon: {
      type: Boolean,
      default: false,
    },
    appendIcon: {
      type: String,
      default: '',
    },
    appendIconTooltip: {
      type: String,
      default: '',
    },
    hideRulesIcon: {
      type: Boolean,
      default: false,
    },
    alignClass: {
      type: String,
      default: 'baseline',
    },
    justifyClass: {
      type: String,
      default: 'space-between',
    },
    paddingRight: {
      type: String,
      default: '',
    },
  },
  computed: {
    computedReadOnly() {
      return this.isEditingOn ? !this.readOnlyField : true;
    },
  },
};
</script>
<style lang="scss" scoped>
.sidebar-form-name {
  color: #202124;
  float: left;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  padding-top: 2px;
  text-align: left;
}
.sidebar-form-input {
  float: left;
  text-align: left;
}
.small-subtitle {
  font-family: Roboto;
  font-style: italic;
  font-weight: 300;
  font-size: 11px;
  line-height: 13px;
  color: rgba(0, 0, 0, 0.59);
}
</style>
